import { useCallback, useContext, useRef } from 'react';

import BreadcrumbsContext from '../BreadcrumbsContext';

let uniqueId = 0;

const useDeferCrumb = () => {
  const { deferCrumb, resolveCrumb } = useContext(BreadcrumbsContext);
  const ref = useRef(null);

  const getUniqueId = useCallback(() => {
    if (ref.current) {
      return ref.current;
    }
    uniqueId += 1;
    ref.current = uniqueId;
    return ref.current;
  }, []);

  const defer = useCallback(() => {
    const id = getUniqueId();
    deferCrumb(id);
    return id;
  }, [deferCrumb, getUniqueId]);

  const resolve = useCallback(
    id => {
      resolveCrumb(id);
    },
    [resolveCrumb],
  );

  return {
    defer,
    resolve,
  };
};

export default useDeferCrumb;
